import React from 'react';
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { ImageAsset } from 'res';

import "./styles.css";

export default function CountryOfResidenceWidget(props) {
    return (
        <div className="country-of-residence-widget">
            <div className="flex-container flex-horizontal align-center-container label-container">
                <div className="flex-width">
                    <span className="sub-text">Country of Residence</span>
                </div>
            </div>

            <DisabledPrompt>
                <div className="flex-container flex-horizontal align-center-container country-of-residence-container clickable">
                    <div className="set-width left-icon-container">
                        <ImageAsset id="UnitedStatesFlagIcon" className="icon" />
                    </div>
                    <div className="flex-width">
                        <p><span>United States</span></p>
                    </div>
                </div>
            </DisabledPrompt>
        </div>
    );
}
